import * as FtsQueries from "../../templates/fts-queries";
import {bool} from "../../templates/compound-queries";
import {relationsByTextQuery} from "./relations-query-partial-builder";

export const ftsSuggestQuery = (termVariable: string, relations?: Array<string>): string => {
  const query = termVariable;
  const analyzer = 'standard';
  const matchPhrase = FtsQueries.matchPhrase({query, boost: 5, analyzer, slop: 3});
  const matchPhrasePrefix = FtsQueries.matchPhrasePrefix({query, boost: 5, analyzer, slop: 3});
  const matchBoolPrefix = FtsQueries.matchBoolPrefix({query, analyzer});
  const multiMatchPhrase = FtsQueries.multiMatch({query, analyzer, type: 'phrase_prefix'});
  const multiMatchKeyword = FtsQueries.multiMatch({query, analyzer: 'keyword'});
  const relationsBlock = relations ? relationsByTextQuery(relations, query) : '';
  return bool.should(`
    # Exact matches
    ${matchPhrase},
    # Partial matches
    ${matchPhrasePrefix},
    # Related partial matches
    ${matchBoolPrefix},
    # Matches from all available fields (phrase prefix)
    ${multiMatchPhrase}
    # Matches from all available fields (keyword)
    ${multiMatchKeyword}
    # Matches from relations
    ${relationsBlock}
  `);
};
